import { withInstall } from '@antdv/utils';
import ATour from './src/Tour';

export const Tour = withInstall(ATour);

export default Tour;

export * from './src/props';
